import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import "./style.css";
import ReportDashboardImg from "../../assets/img/report-dashboard.svg";
import { useDispatch } from "react-redux";
import { getBusinesses } from "../../store/actions/reports/businesses";

const ReportsHomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    /** Per risolvere la perdita della selezione anno liquidazione mentre vado avanti e dietro nei
     * dettagli vado a resettare qui il dato che salvo in localStorage
     */
    localStorage.setItem("report_vat_year", new Date().getFullYear());
    /**
   * Chiamata per recupero business
   */
    dispatch(getBusinesses());
  }, []);

  return (
    <div className="dbx-reports-root">
      <div className="dbx-reports-dashboard">
        <div className="dbx-reports-dashboard-cards">
          <div className="dbx-reports-dashboard-card">
            <div className="dbx-reports-dashboard-card-left">
              <div className="dbx-reports-dashboard-card-icon">
                <FontAwesomeIcon icon={["far", "balance-scale-right"]} />
              </div>
              <div className="dbx-reports-dashboard-card-title">Bilancio</div>
            </div>
            <div
              className="dbx-reports-dashboard-card-right"
              onClick={() => navigate("/reports?model=balance")}
            >
              <div className="dbx-reports-dashboard-card-icon-goTo">
                <FontAwesomeIcon icon={["far", "arrow-right"]} />
              </div>
            </div>
          </div>
          <div className="dbx-reports-dashboard-card">
            <div className="dbx-reports-dashboard-card-left">
              <div className="dbx-reports-dashboard-card-icon">
                <FontAwesomeIcon icon={["far", "university"]} />
              </div>
              <div className="dbx-reports-dashboard-card-title">
                Liquidazione IVA
              </div>
            </div>
            <div
              onClick={() => navigate({pathname: "/reports/vat", search: location.search})}
              className="dbx-reports-dashboard-card-right"
            >
              <div className="dbx-reports-dashboard-card-icon-goTo">
                <FontAwesomeIcon icon={["far", "arrow-right"]} />
              </div>
            </div>
          </div>
          <div className="dbx-reports-dashboard-card">
            <div className="dbx-reports-dashboard-card-left">
              <div className="dbx-reports-dashboard-card-icon">
                <FontAwesomeIcon icon={["far", "university"]} />
              </div>
              <div className="dbx-reports-dashboard-card-title">
                Report IVA
              </div>
            </div>
            <div
              onClick={() => navigate({pathname: "/reports/vat-entries", search: location.search})}
              className="dbx-reports-dashboard-card-right"
            >
              <div className="dbx-reports-dashboard-card-icon-goTo">
                <FontAwesomeIcon icon={["far", "arrow-right"]} />
              </div>
            </div>
          </div>
          { /* Removed Registri IVA tab
           <div className="dbx-reports-dashboard-card">
            <div className="dbx-reports-dashboard-card-left">
              <div className="dbx-reports-dashboard-card-icon">
                <FontAwesomeIcon icon={["far", "university"]} />
              </div>
              <div className="dbx-reports-dashboard-card-title">
                Registri IVA
              </div>
            </div>
            <div
              onClick={() => navigate("/reports?model=vatRegister")}
              className="dbx-reports-dashboard-card-right"
            >
              <div className="dbx-reports-dashboard-card-icon-goTo">
                <FontAwesomeIcon icon={["far", "arrow-right"]} />
              </div>
            </div>
          </div> */}
          <div className="dbx-reports-dashboard-card">
            <div className="dbx-reports-dashboard-card-left">
              <div className="dbx-reports-dashboard-card-icon">
                <FontAwesomeIcon icon={["far", "university"]} />
              </div>
              <div className="dbx-reports-dashboard-card-title">
                Partitario
              </div>
            </div>
            <div
              onClick={() => navigate("/reports?model=ledger")}
              className="dbx-reports-dashboard-card-right"
            >
              <div className="dbx-reports-dashboard-card-icon-goTo">
                <FontAwesomeIcon icon={["far", "arrow-right"]} />
              </div>
            </div>
          </div>
        </div>
        <div className="dbx-reports-dashboard-img">
          <img src={ReportDashboardImg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default ReportsHomePage;
